module.exports = __webpack_public_path__ + "img/wen style2.fb367ce3.png";